import analytics from '@podiumhq/podium-analytica';

import isMocked from 'lib/isMocked';
import isQABot from 'lib/isQABot';

const initAnalyticaEvents = () => {
  if (process.env.NODE_ENV !== 'production' || isQABot() || isMocked()) return;
  analytics.init();
};

export default initAnalyticaEvents;
